import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, notification, Result, Divider, Space } from 'antd';
import { Button, Input, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import {
	XThemeForm,
	XContainer,
	XSelect,
	XCardsTransparent,
	XUploadCustom,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeSelect,
	XThemeGradientButton,
	XThemeUploadProfile,
} from '../../styles/GlobalThemeStyle';
import axios from 'axios';
import { UploadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
// actions
import {
	getInsuranceCompaniesApi,
	getInsuranceCompaniesReset,
} from '../../actions/getInsuranceCompaniesAction';
import {
	addInsuranceCompanyApi,
	addInsuranceCompanyReset,
} from '../../actions/addInsuranceComapnyAction';
import {
	editInsuranceCompanyApi,
	editInsuranceCompanyReset,
} from '../../actions/editInsuranceCompanyAction';
import {
	deleteInsuranceCompanyApi,
	deleteInsuranceCompanyReset,
} from '../../actions/deleteInsuranceCompanyAction';
import {
	getStateDropdownApi,
	getStateDropdownReset,
} from '../../actions/getStateDropdownAction';
import { checkModulePermissions, getUserToken } from '../../utils/helper';
import HeaderFile from '../../components/Header/HeaderFile';
import Header from '../../components/Header/Header';
import {
	filterByLabel,
	handleInputChange,
	lowerCaseInput,
	validateMobileNumber,
} from '../../utils/formFunctions';
import {
	getInsuranceCompanyByIdApi,
	getInsuranceCompanyByIdReset,
} from '../../actions/getInsuranceCompanyByIdAction';
import {
	getStatesListApi,
	getStatesListReset,
} from '../../actions/getStatesListAction';
import config from '../../config';
import {
	XTheme2Button,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';
import {
	XButtonBack,
	XCardBackBg,
	XEditTitle,
} from '../CaseForm/CaseFormStyle';

const { TextArea } = XThemeInputText;

const InsuranceCompanyForm = (props) => {
	const navigate = useNavigate();
	const id = useParams().id;
	const {
		editInsuranceCompany,
		editInsuranceCompanyState,
		addInsuranceCompanyState,
		addInsuranceCompany,
		getInsuranceCompanyByIdState,
		getInsuranceCompanyByIdReset,
		getInsuranceCompanyById,
		addInsuranceCompanyReset,
		editInsuranceCompanyReset,
		deleteInsuranceCompany,
		deleteInsuranceCompanyState,
		deleteInsuranceCompanyReset,
		getStateDropdownState,
		getStateDropdown,
		getStatesList,
		getStatesListState,
	} = props;
	let modulePermissions = checkModulePermissions(
		'insurance-company-management',
	);
	const [form] = XThemeForm.useForm();
	const [formData, setFormData] = useState({});
	console.log('formData', formData);
	// const [editCompanyActive, setEditCompanyActive] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [fileChanged, setFileChanged] = useState(false);
	const [loading, setLoading] = useState(false);
	const [submitLoading, setSubmitLoading] = useState(false);
	const defaultProfilePic = [
		{
			name: 'Test',
			url: '/images/default-pic.svg',
			status: 'done',
		},
	];
	const handleSubmit = async () => {
		try {
			let newFile = {};
			await form.validateFields(); // Wait for form validation

			if (fileList.length > 0 && fileChanged) {
				await Promise.all(
					fileList.map(async (fileData) => {
						let get_ext = fileData.originFileObj.name.split('.');
						let ext = get_ext[get_ext.length - 1];
						const res = await axios.get(
							`${config.api.base_url}/settings/get-signed-url?action=putObject&folder_name=insurance_companies&file_name=${formData.name}&ext=${ext}&id=${fileData.originFileObj.uid}`,
							{
								headers: {
									'Content-type':
										'application/json; charset=UTF-8',
									Authorization: 'Bearer ' + getUserToken(),
								},
							},
						);

						const result = await axios.put(
							res.data.data,
							fileData.originFileObj,
						);

						if (result.status === 200) {
							const documentPath = `/insurance_companies/${fileData.originFileObj.uid}/${formData.name}.${ext}`;
							newFile = {
								uid: fileData.originFileObj.uid,
								name: fileData.originFileObj.name,
								status: 'done',
								url: documentPath,
							};
						}
					}),
				);
				console.log('Files Uploaded');
			}

			// if (!fileChanged) {
			// 	// Create a URL object and extract the pathname to give old file path without adding s3 url when edit
			// 	let file = fileList[0];
			// 	const url = new URL(file.url);
			// 	const exactDocPath = url.pathname;
			// 	fileList[0].url = exactDocPath;
			// }

			if (formData.id) {
				await editInsuranceCompany({
					...formData,
					...(fileChanged
						? { logo: newFile }
						: { logo: formData.logo }),
					// : { logo: fileList[0] }),
				});
			} else {
				await addInsuranceCompany({
					...formData,
					...(fileChanged
						? { logo: newFile }
						: { logo: fileList[0] }),
				});
			}
		} catch (error) {
			// Handle error if any
			notification.error({
				message: 'An error occurred',
			});
			console.error('Error occurred:', error);
		}
	};

	const handleState = (name, value) => {
		setFormData({
			...formData,
			[name]: value,
		});
	};

	const handleChange = (info) => {
		let newFileList = [...info.fileList];

		// 1. Limit the number of uploaded files
		// Only to show two recent uploaded files, and old ones will be replaced by the new
		newFileList = newFileList.slice(-2);

		// 2. Read from response and show file link
		newFileList = newFileList.map((file) => {
			if (file.response) {
				// Component will show file.url as link
				file.url = file.response.url;
				return { ...file, status: 'done' };
			}
			return file;
		});
		setFileChanged(true);
		setFileList(newFileList);
	};

	useEffect(() => {
		if (editInsuranceCompanyState.apiState === 'success') {
			setSubmitLoading(false);
			form.resetFields();
			setFormData({});
			setFileList([]);
			setFileChanged(false);
			editInsuranceCompanyReset();
			// getInsuranceCompanies();
			notification.success({
				message: editInsuranceCompanyState.message,
			});
			navigate(-1);
			// setModalOpen([false, '']);
		} else if (editInsuranceCompanyState.apiState === 'error') {
			notification.error({
				message: editInsuranceCompanyState.message,
			});
			editInsuranceCompanyReset();
			navigate(-1);
		}
	}, [editInsuranceCompanyState]);

	useEffect(() => {
		if (addInsuranceCompanyState.apiState === 'success') {
			setSubmitLoading(false);
			form.resetFields();
			setFormData({});
			setFileList([]);
			setFileChanged(false);

			addInsuranceCompanyReset();
			notification.success({
				message: addInsuranceCompanyState.message,
			});
			navigate(-1);
			// setModalOpen([false, '']);
		} else if (addInsuranceCompanyState.apiState === 'error') {
			notification.error({
				message: 'Error is adding Provider.',
			});
			addInsuranceCompanyReset();
			navigate(-1);
		}
	}, [addInsuranceCompanyState]);

	useEffect(() => {
		console.log('form in effect', formData);
		if (id) {
			setLoading(true);
			getInsuranceCompanyById({ id: id });
		}
		// localStorage.getItem('role') === 'organization-admin' && getRegions();
		// getStateDropdown();
		// getOrganizations();
	}, [id]);
	console.log(
		'getInsuranceCompanyByIdState----',
		getInsuranceCompanyByIdState,
	);

	useEffect(() => {
		if (getInsuranceCompanyByIdState.apiState === 'success') {
			setFormData({
				id: getInsuranceCompanyByIdState.data._id,
				name: getInsuranceCompanyByIdState.data.name,
				contact_person_email_address:
					getInsuranceCompanyByIdState.data
						.contact_person_email_address,
				contact_person_mobile_number:
					getInsuranceCompanyByIdState.data
						.contact_person_mobile_number,
				fax_number: getInsuranceCompanyByIdState.data.fax_number,
				address: getInsuranceCompanyByIdState.data.address,
				functional_in_states:
					getInsuranceCompanyByIdState.data.functional_in_states,
				hq_state: getInsuranceCompanyByIdState.data.hq_state,
				pincode: getInsuranceCompanyByIdState.data.pincode,
				city: getInsuranceCompanyByIdState.data.city,
				updatedAt: getInsuranceCompanyByIdState.data.updatedAt,
				logo: getInsuranceCompanyByIdState.data.logo,
			});
			form.setFieldsValue({
				id: getInsuranceCompanyByIdState.data._id,
				name: getInsuranceCompanyByIdState.data.name,
				contact_person_email_address:
					getInsuranceCompanyByIdState.data
						.contact_person_email_address,
				contact_person_mobile_number:
					getInsuranceCompanyByIdState.data
						.contact_person_mobile_number,
				fax_number: getInsuranceCompanyByIdState.data.fax_number,
				address: getInsuranceCompanyByIdState.data.address,
				functional_in_states:
					getInsuranceCompanyByIdState.data.functional_in_states,
				hq_state: getInsuranceCompanyByIdState.data.hq_state,

				pincode: getInsuranceCompanyByIdState.data.pincode,
				city: getInsuranceCompanyByIdState.data.city,
				updatedAt: getInsuranceCompanyByIdState.data.updatedAt,
			});
			if (getInsuranceCompanyByIdState.data.logo !== null) {
				const updatedLogo = {
					...getInsuranceCompanyByIdState.data.logo,
					url: `${config.s3_url}${getInsuranceCompanyByIdState.data.logo.url}`,
				};
				setFileList([updatedLogo]);
			}
			setLoading(false);
			getInsuranceCompanyByIdReset();
		} else if (getInsuranceCompanyByIdState.apiState === 'error') {
			notification.error({
				message: 'Error in get insurance company.',
			});
			getInsuranceCompanyByIdReset();
			navigate(-1);
		}
	}, [getInsuranceCompanyByIdState]);

	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Insurance Company" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="insuranceCompany" />
					</Col>
				</>
			)}
			<Spin spinning={loading}>
				<XThemeContainer fluid>
					<XCardBackBg className="mb-3 d-lg-none">
						<Row>
							<Col xs={24}>
								<XButtonBack
									onClick={() => navigate(-1)}
									icon={<ArrowLeftOutlined />}
									size="large"
								/>
								{id ? (
									<XEditTitle>
										Edit Insurance Company
									</XEditTitle>
								) : (
									<XEditTitle>
										Add Insurance Company
									</XEditTitle>
								)}{' '}
							</Col>
						</Row>
					</XCardBackBg>
					<Row gutter={[15, 15]} className="align-items-center mb-4">
						<Col
							xs={24}
							sm={24}
							md={12}
							lg={12}
							xl={12}
							className="text-center text-md-start"
						>
							<XTheme2MainTitle className="mb-2">
								{id
									? 'Edit Insurance Company'
									: 'Add Insurance Company'}{' '}
							</XTheme2MainTitle>
						</Col>
					</Row>

					<XThemeDetailsCards className="noBGMobile largePadding mb-3">
						{checkModulePermissions(
							'insurance-company-management',
						).sub_modules.includes(
							'add-insurance-companies',
							'update-insurance-companies',
						) ? (
							<>
								<XThemeForm
									form={form}
									name="roleForm"
									layout="vertical"
									autoComplete="off"
									onFinish={() => {
										// editCompanyActive
										// 	? updateInsuranceComapnySubmit()
										// 	: addInsuranceComapnySubmit();
										setSubmitLoading(true);
										handleSubmit();
									}}
								>
									<Row gutter={(15, 15)}>
										<Col xs={24} sm={24} md={8} lg={8}>
											<div className="borderRightOnly">
												<XThemeForm.Item
													name="logo"
													// label="Upload Logo"
													rules={[
														{
															required: true,
															validator: (
																_,
																value,
															) => {
																if (
																	fileList.length ===
																	0
																) {
																	return Promise.reject(
																		new Error(
																			'Please add logo!',
																		),
																	);
																}
																return Promise.resolve();
															},
														},
													]}
												>
													<XThemeUploadProfile
														listType="picture-circle"
														maxCount={1}
														accept="image/png, image/jpeg, image/jpg"
														// fileList={fileList}
														fileList={
															fileList.length > 0
																? fileList
																: defaultProfilePic
														}
														showUploadList={{
															showPreviewIcon: false,
															showRemoveIcon: true,
														}}
														onChange={handleChange}
													>
														{/* <UploadOutlined /> */}
														Upload Logo
													</XThemeUploadProfile>
												</XThemeForm.Item>
											</div>
										</Col>
										<Col xs={24} sm={24} md={16} lg={16}>
											<Row gutter={(15, 15)}>
												<Col
													xs={24}
													sm={24}
													md={12}
													lg={12}
												>
													<XThemeForm.Item
														className="drawerlabel"
														name="name"
														label="Name"
														rules={[
															{
																required: true,
																message:
																	'Please enter Company name',
															},
														]}
													>
														<XThemeInputText
															className="largeInputForms"
															prefix={
																<img
																	src="/images/input-user-icon.svg"
																	alt=""
																/>
															}
															size="large"
															placeholder="Enter Company Name"
															name="name"
															onChange={(e) =>
																handleInputChange(
																	e,
																	formData,
																	setFormData,
																)
															}
														/>
													</XThemeForm.Item>
												</Col>
												<Col
													xs={24}
													sm={24}
													md={12}
													lg={12}
												>
													<XThemeForm.Item
														className="drawerlabel"
														name="contact_person_email_address"
														label="Contact Person Email Address"
														rules={[
															{
																type: 'email',
																message:
																	'Please enter a valid email address',
															},
														]}
													>
														<XThemeInputText
															className="largeInputForms"
															prefix={
																<img
																	src="/images/input-email-icon.svg"
																	alt=""
																/>
															}
															size="large"
															placeholder="Enter Contact Person Email Address"
															name="contact_person_email_address"
															onInput={
																lowerCaseInput
															}
															onChange={(e) =>
																handleInputChange(
																	e,
																	formData,
																	setFormData,
																)
															}
														/>
													</XThemeForm.Item>
												</Col>
												<Col
													xs={24}
													sm={24}
													md={12}
													lg={12}
												>
													<XThemeForm.Item
														className="drawerlabel"
														name="contact_person_mobile_number"
														label="Contact Person Mobile Number"
														rules={[
															{
																validator:
																	validateMobileNumber,
															},
														]}
													>
														<XThemeInputText
															className="largeInputForms"
															prefix={
																<img
																	src="/images/input-mobile-icon.svg"
																	alt=""
																/>
															}
															size="large"
															placeholder="Enter Contact Person Mobile Number"
															name="contact_person_mobile_number"
															onChange={(e) =>
																handleInputChange(
																	e,
																	formData,
																	setFormData,
																)
															}
														/>
													</XThemeForm.Item>
												</Col>
												<Col
													xs={24}
													sm={24}
													md={12}
													lg={12}
												>
													<XThemeForm.Item
														className="drawerlabel"
														name="fax_number"
														label="Fax Number"
													>
														<XThemeInputText
															className="largeInputForms"
															prefix={
																<img
																	src="/images/input-fax-icon.svg"
																	alt=""
																/>
															}
															size="large"
															placeholder="Enter Fax Number"
															name="fax_number"
															onChange={(e) =>
																handleInputChange(
																	e,
																	formData,
																	setFormData,
																)
															}
														/>
													</XThemeForm.Item>
												</Col>

												<Col xs={24}>
													<XThemeForm.Item
														className="drawerlabel"
														name="address"
														label="Address"
													>
														<XThemeInputText
															className="largeInputForms"
															prefix={
																<img
																	src="/images/input-location-icon.svg"
																	alt=""
																/>
															}
															size="large"
															placeholder="Enter Address"
															name="address"
															onChange={(e) =>
																handleInputChange(
																	e,
																	formData,
																	setFormData,
																)
															}
														/>
													</XThemeForm.Item>
												</Col>
												<Col
													xs={24}
													sm={24}
													md={12}
													lg={12}
												>
													<XThemeForm.Item
														className="drawerlabel"
														name="hq_state"
														label={'HQ State'}
													>
														<XThemeSelect
															className="largeInputForms"
															size="large"
															placeholder="Select State"
															name="hq_state"
															showSearch={true}
															defaultValue={
																formData.hq_state
															}
															onFocus={() => {
																getStatesList();
															}}
															filterOption={
																filterByLabel
															}
															options={
																getStatesListState.apiState ===
																	'success' &&
																getStatesListState
																	.data
																	.all_states
																	?.length >
																	0 &&
																getStatesListState.data.all_states.map(
																	(itm) => {
																		return {
																			label: itm.state,
																			value: itm.state,
																			providers:
																				itm.providers,
																		};
																	},
																)
															}
															onChange={(
																value,
																options,
															) => {
																handleState(
																	'hq_state',
																	value,
																);
															}}
														/>
													</XThemeForm.Item>
												</Col>
												<Col
													xs={24}
													sm={24}
													md={12}
													lg={12}
												>
													<XThemeForm.Item
														className="drawerlabel"
														name="functional_in_states"
														label={
															'Functional In States'
														}
													>
														<XThemeSelect
															className="largeInputForms"
															size="large"
															mode="multiple"
															placeholder="Select States"
															name="functional_in_states"
															maxTagCount={
																(3,
																'responsive')
															}
															showSearch={true}
															defaultValue={
																formData.functional_in_states
															}
															onFocus={() => {
																getStatesList();
															}}
															onSearch={(
																search,
															) => {
																if (
																	search.length >=
																	3
																) {
																	getStatesList(
																		{
																			search,
																		},
																	);
																} else if (
																	search.length ===
																	0
																) {
																	getStatesList();
																}
															}}
															filterOption={
																filterByLabel
															}
															options={
																getStatesListState.apiState ===
																	'success' &&
																getStatesListState
																	.data
																	.all_states
																	?.length >
																	0 &&
																getStatesListState.data.all_states.map(
																	(itm) => {
																		return {
																			label: itm.state,
																			value: itm.state,
																			providers:
																				itm.providers,
																		};
																	},
																)
															}
															onChange={(
																value,
																options,
															) => {
																// handleInputChange(
																// 	value,
																// 	formData,
																// 	setFormData,
																// );
																handleState(
																	'functional_in_states',
																	value,
																);
															}}
														/>
													</XThemeForm.Item>
												</Col>
												<Col
													xs={24}
													sm={24}
													md={12}
													lg={12}
												>
													<XThemeForm.Item
														className="drawerlabel"
														name="pincode"
														label="Pincode"
													>
														<XThemeInputText
															className="largeInputForms"
															prefix={
																<img
																	src="/images/input-location-icon.svg"
																	alt=""
																/>
															}
															size="large"
															placeholder="Enter Pincode"
															name="pincode"
															onChange={(e) =>
																handleInputChange(
																	e,
																	formData,
																	setFormData,
																)
															}
														/>
													</XThemeForm.Item>
												</Col>
												<Col
													xs={24}
													sm={24}
													md={12}
													lg={12}
												>
													<XThemeForm.Item
														className="drawerlabel"
														name="city"
														label="City"
													>
														<XThemeInputText
															className="largeInputForms"
															prefix={
																<img
																	src="/images/input-location-icon.svg"
																	alt=""
																/>
															}
															size="large"
															placeholder="Enter City"
															name="city"
															onChange={(e) =>
																handleInputChange(
																	e,
																	formData,
																	setFormData,
																)
															}
														/>
													</XThemeForm.Item>
												</Col>
											</Row>
											<Row gutter={[15, 15]}>
												<Col
													xs={24}
													className="text-center text-sm-end"
												>
													<Space>
														<XTheme2Button
															className="noBackground borderColor submitCancel px-4"
															shape="round"
															onClick={() => {
																form.resetFields();
																setFormData({});
																setFileList([]);
																navigate(
																	'/insurance-company',
																);
															}}
														>
															Cancel
														</XTheme2Button>
														<XTheme2Button
															className="submitCancel px-4"
															shape="round"
															loading={
																submitLoading
															}
															htmlType="submit"
														>
															Submit
														</XTheme2Button>
													</Space>
												</Col>
											</Row>
										</Col>
									</Row>
								</XThemeForm>
							</>
						) : (
							<Result
								status="403"
								title="403"
								subTitle="Sorry, you are not authorized to access this page."
								extra={
									<Button
										type="primary"
										onClick={() => navigate('/')}
									>
										Back Home
									</Button>
								}
							/>
						)}
					</XThemeDetailsCards>
				</XThemeContainer>
			</Spin>
		</>
	);
};

const mapStateToProps = (state) => ({
	addInsuranceCompanyState: state.addInsuranceCompany,
	editInsuranceCompanyState: state.editInsuranceCompany,
	getInsuranceCompanyByIdState: state.getInsuranceCompanyById,
	deleteInsuranceCompanyByIdState: state.deleteInsuranceCompanyById,
	deleteInsuranceCompanyState: state.deleteInsuranceCompany,
	getStateDropdownState: state.getStateDropdown,
	getStatesListState: state.getStatesList,
});

const mapDispatchToProps = (dispatch) => ({
	addInsuranceCompany: (data) => dispatch(addInsuranceCompanyApi(data)),
	addInsuranceCompanyReset: () => dispatch(addInsuranceCompanyReset()),
	editInsuranceCompany: (data) => dispatch(editInsuranceCompanyApi(data)),
	editInsuranceCompanyReset: () => dispatch(editInsuranceCompanyReset()),
	getInsuranceCompanyById: (data) =>
		dispatch(getInsuranceCompanyByIdApi(data)),
	getInsuranceCompanyByIdReset: () =>
		dispatch(getInsuranceCompanyByIdReset()),
	deleteInsuranceCompany: (data) => dispatch(deleteInsuranceCompanyApi(data)),
	deleteInsuranceCompanyReset: () => dispatch(deleteInsuranceCompanyReset()),
	getStateDropdown: (params) => dispatch(getStateDropdownApi(params)),
	getStateDropdownReset: () => dispatch(getStateDropdownReset()),
	getStatesList: (params) => dispatch(getStatesListApi(params)),
	getStatesListReset: () => dispatch(getStatesListReset()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(InsuranceCompanyForm);
